<template>
  <div class="iframe-editor-tool">
    <b-form-input
        v-model="addIframeOnEditor"
        placeholder="لینک iframe را وارد کنید"
        class="iframe-editor-tool__input"/>
    <button
        type="button"
        class="iframe-editor-tool__btn"
        @click="addIframe(addIframeOnEditor)">
      اضافه کردن iframe
    </button>
  </div>
</template>

<script>
export default {
  name: "AddImageToEditor",
  props: {
    title: {
      default: ''
    }
  },
  data() {
    return {
      addIframeOnEditor: '',
    }
  },
  methods: {
    addIframe(iframe) {
      if (!iframe) return;
      iframe = `<iframe v-resize width="100%" src="${iframe}" frameborder="0" ></iframe>`;
      this.$emit('iframe-handler', iframe)
      this.addIframeOnEditor = ''
    },
  }
}
</script>

<style scoped>
.iframe-editor-tool {
  display: flex;
  flex-wrap: wrap;
  gap: 0.55rem;
  align-items: center;
  width: 100%;
}

.iframe-editor-tool__input {
  flex: 1 1 220px;
  min-width: 0;
  height: 38px;
  border-radius: 999px !important;
  border: 1px solid rgba(30, 30, 30, 0.12) !important;
  background: #fff !important;
}

.iframe-editor-tool__btn {
  flex: 0 0 auto;
  height: 38px;
  padding: 0 1rem;
  border: 0;
  border-radius: 999px;
  background: var(--primary, #eb3d60);
  color: #fff;
  font-size: 0.84rem;
  font-weight: 700;
  cursor: pointer;
}

.iframe-editor-tool__btn:hover {
  filter: brightness(0.95);
}
</style>
